import React from "react";
import { Box, Divider, Skeleton, Typography } from "@mui/material";
import RecommendedSettingConfigCard from "./RecommendedSettingConfigCard";
import { COLORS } from "../../../ui/Theme";
import { useRecommendedContext } from "../../../context/recommended/RecommendedContext";
import useResponsive from "../../../components/hooks/useResponsive";
import RecommendedSettingConfigCardMobile from "./RecommendedSettingConfigCardMobile";
import Grid2 from "@mui/material/Unstable_Grid2";
import { ListDivider } from "../../../ui/ListStyles";

const RecommendedSettingConfig = ({ title, keyName }) => {
  const { configData, tableData, setConfigData } = useRecommendedContext();

  const { isMd } = useResponsive();

  // TOGGLE ALL CHECKBOXES
  const handleSelectAll = () => {
    const allSelected = configData.defaultConfig[keyName]?.every(
      (item) => item.is_enabled
    );
    const updatedData = configData.defaultConfig[keyName]?.map((item) => ({
      ...item,
      is_enabled: !allSelected,
    }));
    updateSettingConfig(keyName, updatedData);
  };

  // TOGGLE CHECKBOXES INDIVIDUALLY
  const handleCheckboxChange = (index) => {
    const updatedData = configData.defaultConfig[keyName]?.map((item, idx) =>
      idx === index ? { ...item, is_enabled: !item.is_enabled } : item
    );
    updateSettingConfig(keyName, updatedData);
  };

  //UPDATE SETTING CONFIG FOR CHECKBOXES
  const updateSettingConfig = (key, updatedArray) => {
    setConfigData((prevConfig) => ({
      ...prevConfig,
      defaultConfig: {
        ...prevConfig.defaultConfig,
        [key]: updatedArray,
      },
    }));
  };

  // TEXTFIELD CHANGE
  const handleInputChange = (index, key, value) => {
    const updatedData = configData.defaultConfig[keyName]?.map((item, idx) =>
      idx === index ? { ...item, [key]: value } : item
    );
    updateSettingConfig(keyName, updatedData);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "20px",
        }}
      >
        <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
          {title}
        </Typography>
        <ListDivider sx={{ flexGrow: 1 }} />
        <Typography
          onClick={handleSelectAll}
          sx={{
            fontWeight: "bold",
            fontSize: "12px",
            color: COLORS.BLUE,
            cursor: "pointer",
          }}
        >
          انتخاب همه
        </Typography>
      </Box>
      <Grid2 container spacing={"20px"}>
        {tableData?.isValidating || !configData.defaultConfig?.foundamental
          ? isMd
            ? Array.from({ length: 6 }).map((_, index) => (
                <Grid2 md={6} lg={4} xl={2.4} key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      padding: 2,
                      borderRadius: "10px",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    <Skeleton
                      variant="text"
                      width="20%"
                      height={30}
                      animation="wave"
                    />
                    <ListDivider />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Skeleton
                        variant="text"
                        width="25%"
                        height={30}
                        animation="wave"
                      />
                      <Skeleton
                        variant="rounded"
                        width="20%"
                        height={40}
                        animation="wave"
                      />
                    </Box>
                  </Box>
                </Grid2>
              ))
            : Array.from({ length: 3 }).map((_, index) => (
                <Grid2 xs={12} key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1.5,
                      padding: 2,
                      borderRadius: "10px",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    <Skeleton
                      variant="text"
                      width="100%"
                      height={25}
                      animation="wave"
                    />
                  </Box>
                </Grid2>
              ))
          : configData.defaultConfig[keyName]?.map((item, index) =>
              isMd ? (
                <RecommendedSettingConfigCard
                  key={index}
                  data={item}
                  isChecked={item.is_enabled}
                  onCheckboxChange={() => handleCheckboxChange(index)}
                  onInputChange={(key, value) =>
                    handleInputChange(index, key, value)
                  }
                />
              ) : (
                <RecommendedSettingConfigCardMobile
                  key={index}
                  data={item}
                  isChecked={item.is_enabled}
                  onCheckboxChange={() => handleCheckboxChange(index)}
                  onInputChange={(key, value) =>
                    handleInputChange(index, key, value)
                  }
                />
              )
            )}
      </Grid2>
    </>
  );
};

export default RecommendedSettingConfig;
